import { toHHMMSS } from "@/utils/functions/time";
import { Typography } from "@mui/material";
import { FC } from "react";

interface MissionDurationColumnProps {
  duration?: number;
}

const MissionDurationColumn: FC<MissionDurationColumnProps> = ({ duration }) => {
  if (duration) {
    return <Typography>{toHHMMSS(`${duration}`)}</Typography>;
  }

  return <Typography>-</Typography>;
};

export default MissionDurationColumn;
